import { render, staticRenderFns } from "./payments-modal.vue?vue&type=template&id=df894d5c&"
import script from "./payments-modal.vue?vue&type=script&lang=js&"
export * from "./payments-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports